export const devoirs = [
  {
    matiere: "Mathématiques",
    date: "2025-09-10",
    description: "Exercices 15 à 20 page 123",
    rendu: false
  },
  {
    matiere: "Français",
    date: "2025-09-11",
    description: "Lecture du chapitre 4 du livre 'L'Étranger'",
    rendu: true
  },
  {
    matiere: "Histoire",
    date: "2025-09-12",
    description: "Réviser la Révolution française",
    rendu: false
  },
];